// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3Ua_j","sendOtp":"AuthorizeToLogin_sendOtp__ScLdv"};